import React, { Component } from 'react'
import { Context } from '../../Context'
import logo from '../../../assets/rhomberg-logo.svg'
import AnimatedLogo from '../../Libs/AnimatedLogo'

export default class BauserviceLeistungenVerputzerteam extends Component {
    static contextType = Context

    constructor(props) {
        super(props)

        this.state = {
            backgroundImages: [
                '/bauservice/image-01.jpg',
                '/bauservice/image-02.jpg',
                '/bauservice/image-03.jpg',
                '/bauservice/image-04.jpg',
                '/bauservice/image-05.jpg',
                '/bauservice/image-06.jpg',
                '/bauservice/image-07.jpg',
            ],
            visible: true,
            backgroundImageIndex: 0,
        }
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer)
        }
    }

    componentWillMount() {
        this.state.backgroundImages.map(imageUrl => {
            const img = new Image()
            img.src = imageUrl
        })
    }

    componentDidMount() {
        setTimeout(() => {
            this.timer = this._onChanceImage(this.state.backgroundImageIndex)
        }, 5000)
    }

    render() {
        return (
            <div className="main background-dark">
                <h1 style={{ marginLeft: 115 }} className="page-title page-title-absolute text-white">
                    Bauservice
                </h1>
                <h2 style={{ marginLeft: 115 }} className="page-title-sub text-white " />
                <AnimatedLogo image={logo} />
                <div className="row h-100">
                    <div className="col-12 col-md-6 h-100">
                        <div className="row h-100 justify-content-center">
                            <div className="col-md-9">
                                <p className="text-red" style={{ fontSize: 40 }}>
                                    NEU: Verputzarbeiten
                                </p>
                                <div className="detail-list color-white">
                                    <p>Die Partie für Innen- und Außenputzarbeiten, Dämmfassaden und Lehmputzwände - Von Klein- bis hin zu Großaufträgen in bester Qualität</p>
                                    <p>
                                        Seit vergangenem Jahr sind sie im Einsatz – die Professionisten mit der Hand an der Spachtel – und übernehmen Verputzarbeiten aller Art und aller
                                        Größenordnungen.
                                    </p>
                                    <p style={{ fontSize: 40 }}>
                                        Innen- und <br />
                                        Außenputzarbeiten
                                    </p>
                                    <p style={{ fontSize: 40 }}>
                                        Erstellen von <br />
                                        Dämmfassaden
                                    </p>
                                    <p style={{ fontSize: 40 }}>
                                        Wohnklimafreundliche <br />
                                        Lehmputzwände
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 h-100" />
                </div>
                <img className={this.state.visible ? 'fade-in' : 'fade-out'} style={{ position: 'absolute', right: 0 }} src={this.state.backgroundImages[this.state.backgroundImageIndex]} />
            </div>
        )
    }

    _onChanceImage() {
        let maxImageCount = this.state.backgroundImages.length
        let backgroundImageIndex = this.state.backgroundImageIndex + 1
        if (backgroundImageIndex >= maxImageCount) {
            backgroundImageIndex = 0
        }

        this.setState({
            visible: false,
        })

        this.timer = setTimeout(() => {
            this.setState(
                {
                    backgroundImageIndex,
                },
                () => {
                    this.setState(
                        {
                            visible: true,
                        },
                        () => {
                            this.timer = setTimeout(() => {
                                this._onChanceImage()
                            }, 2500)
                        },
                    )
                },
            )
        }, 2500)
    }
}
